import { AssociateGuard } from './core/guards/associate.guard';
import { UserGuard } from './core/guards/user.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './core/guards/admin.guard';
import { ForgotPasswordComponent } from './core/pages/forgot-password/forgot-password.component';
import { LoginComponent } from './core/pages/login/login.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'esqueci-senha', component: ForgotPasswordComponent },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canActivate: [AdminGuard], canLoad: [AdminGuard] },
  { path: 'portal', loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule) },
  { path: 'user', loadChildren: () => import('./users/users.module').then(m => m.UsersModule), canActivate: [UserGuard], canLoad: [UserGuard] },

  //Associados
  { path: 'igreja', loadChildren: () => import('./church/church.module').then(m => m.ChurchModule), canActivate: [AssociateGuard], canLoad: [AssociateGuard] },
  { path: 'missionario', loadChildren: () => import('./missionary/missionary.module').then(m => m.MissionaryModule), canActivate: [AssociateGuard], canLoad: [AssociateGuard] },
  { path: 'banda-cantor', loadChildren: () => import('./bands-singers/bands-singers.module').then(m => m.BandsSingersModule), canActivate: [AssociateGuard], canLoad: [AssociateGuard] },
  { path: 'comercio', loadChildren: () => import('./commerce/commerce.module').then(m => m.CommerceModule), canActivate: [AssociateGuard], canLoad: [AssociateGuard] },
  { path: 'servico', loadChildren: () => import('./service-provider/service-provider.module').then(m => m.ServiceProviderModule), canActivate: [AssociateGuard], canLoad: [AssociateGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
